import { render, staticRenderFns } from "./Brand_Payment.vue?vue&type=template&id=362a09a8&"
import script from "./Brand_Payment.vue?vue&type=script&lang=js&"
export * from "./Brand_Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports